import { useEffect, useState } from "react";
import { axiosInstance } from "../../utils/axiosInstance";
import DrugCard from "./ShopDrugCard"; // Ensure this path is correct and the component is properly exported
import { AiOutlineReload } from "react-icons/ai";

const Shopping = () => {
  const [drugs, setDrugs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchDrugs = async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await axiosInstance.get("/drugs/drug");
      if (Array.isArray(res.data.data)) {
        setDrugs(res.data.data);
      } else {
        setError("Unexpected response format.");
      }
    } catch (err) {
      setError("Failed to fetch drugs. Please try again later.");
      console.error("API Error:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDrugs();
  }, []);

  return (
    <div className="flex flex-col gap-6 mt-10 px-4">
      {/* Hero Section */}
      <div className="bg-green-500 text-white py-10 px-6 rounded-lg shadow-md text-center">
        <h1 className="text-3xl font-bold">Welcome to Our Pharmacy!</h1>
        <p className="mt-2 text-lg">
          Explore a wide variety of drugs and healthcare products available at
          your fingertips.
        </p>
      </div>

      {/* Main Content */}
      {error ? (
        <div className="text-center p-6 bg-red-100 text-red-700 rounded-lg shadow-md">
          <p className="mb-4">{error}</p>
          <button
            onClick={fetchDrugs}
            className="flex items-center gap-2 px-4 py-2 bg-green-500 text-white rounded-md shadow-md hover:bg-green-600 transition"
          >
            <AiOutlineReload /> Retry
          </button>
        </div>
      ) : loading ? (
        <div className="flex justify-center items-center h-40">
          <div className="loader border-t-4 border-green-500 w-12 h-12 rounded-full animate-spin"></div>
        </div>
      ) : drugs.length === 0 ? (
        <div className="text-center p-6 bg-gray-100 rounded-lg shadow-md">
          <img
            src="/images/no-drugs.svg"
            alt="No drugs available"
            className="w-40 mx-auto mb-4"
          />
          <p>No drugs available at the moment. Please check back later.</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {drugs.map((drug) => (
            <DrugCard key={drug._id} drug={drug} />
          ))}
        </div>
      )}
    </div>
  );
};

export default Shopping;
